<template>
  <div
    id="main-template-container"
    v-bind:class="{ 'main-template-min-sidebar': minSidebar }"
  >
    <div class="main-template--top-sidebar">
      <div class="main-template--top-sidebar--title">
        <h4>
          <router-link tag="a" :to="`/`"><b>Enroller</b></router-link>
        </h4>
      </div>
      <div class="main-template--top-sidebar--humburger">
        <f-awesome
          @click="toggleSidebar"
          icon="bars"
          id="main-template-humburger"
        ></f-awesome>
        <!--            <i id="main-template-humburger" class="fas fa-bars"></i>-->
      </div>
      <div class="main-template--top-sidebar--bell">
        <bell></bell>
      </div>
      <div class="main-template--top-sidebar--null">
        <div
          style="background-color:transparent;"
          class="btn-sm cursor-pointer noselect main-template--top-sidebar--notifications">
          <i class="fas fa-bell text-orange"></i>
          <span
            class="badge main-template--top-sidebar--notifications-count"
          ></span>
          <span
            class="display-none main-template--top-sidebar--notifications-list"
          >
          </span>
        </div>
      </div>

      <div class="main-template--top-sidebar--account no-select">
        <div
          @click="toggleAccountBar"
          class="noselect main-template--top-sidebar-email"
        >
          <div class="incognito-icon">
            <img width="30" src="@/assets/img/icons/incognito-form.svg">
          </div>
        </div>
        <f-awesome class="angle-account" v-if="showAccountBar" @click="toggleAccountBar" icon="angle-down"></f-awesome>
        <f-awesome class="angle-account" v-if="!showAccountBar" @click="toggleAccountBar" icon="angle-up"></f-awesome>

        <div @click="toggleAccountBar" v-show="showAccountBar" class="backside-account-more"></div>

        <div
          v-show="showAccountBar"
          class="main-template--top-sidebar--account-more"
        >
          <div class="head">
            <div>{{ userEmail }}</div>
            <div v-if="checkPermission('user')" class="">
              <balance :websocketObserveOn="true" class="mrg-t-10"></balance>
            </div>
          </div>
          <div class="links">
            <router-link v-if="checkPermission('user')" tag="a" :to="`/payment/`" class="item">
              <div>
                <f-awesome icon="hand-holding-usd"></f-awesome>
              </div>
              <div class="text-underline">
                Оплата услуг
              </div>
            </router-link>
            <router-link tag="a" :to="`/account/`" class="item">
              <div>
                <f-awesome icon="id-card"></f-awesome>
              </div>
              <div class="text-underline">
                Мой аккаунт
              </div>
            </router-link>
            <router-link v-if="checkPermission('user')" tag="a" :to="`/config/`" class="item">
              <div>
                <f-awesome icon="cog"></f-awesome>
              </div>
              <div class="text-underline">
                Настройки
              </div>
            </router-link>
            <router-link tag="a" :to="`/support/`" class="item">
              <div>
                <f-awesome icon="question-circle"></f-awesome>
              </div>
              <div class="text-underline">
                Поддержка
              </div>
            </router-link>

            <div @click="logout" class="item mrg-t-15">
              <div>
                <f-awesome icon="power-off"></f-awesome>
              </div>
              <div class="text-underline">
                Выйти
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="main-template--left-sidebar no-select">
      <ul>
        <li v-if="checkPermission('show_journal')">
          <router-link tag="a" :to="`/journal/`">
            <div>
              <f-awesome icon="clipboard-list"></f-awesome>
            </div>
            <div>
              Журнал записей
            </div>
          </router-link>
        </li>
        <li v-if="checkPermission('show_services')">
          <router-link tag="a" :to="`/services/`">
            <div>
              <f-awesome icon="shopping-cart"></f-awesome>
            </div>
            <div>
              Услуги
            </div>
          </router-link>
        </li>
        <li v-if="checkPermission('show_staff')">
          <router-link tag="a" :to="`/staff/`">
            <div>
              <f-awesome icon="users"></f-awesome>
            </div>
            <div>
              Сотрудники
            </div>
          </router-link>
        </li>
        <li v-if="checkPermission('show_schedule')">
          <router-link tag="a" :to="`/schedule/`">
            <div>
              <f-awesome icon="calendar-alt"></f-awesome>
            </div>
            <div>
              Расписание
            </div>
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="`/my-data/`">
            <div>
              <f-awesome icon="database"></f-awesome>
            </div>
            <div>
              Компании/Филиалы
            </div>
          </router-link>
        </li>
        <li v-if="checkPermission('user')">
          <router-link tag="a" :to="`/add-account/`">
            <div>
              <f-awesome icon="user-plus"></f-awesome>
            </div>
            <div>
              Доп.аккаунты
            </div>
          </router-link>
        </li>
        <li v-if="checkPermission('show_integrate')">
          <router-link tag="a" :to="`/integrate/`">
            <div>
              <f-awesome icon="globe-europe"></f-awesome>
            </div>
            <div>
              Запись онлайн
            </div>
          </router-link>
        </li>
        <li v-if="checkPermission('show_clients')">
          <router-link tag="a" :to="`/clients/`">
            <div>
              <f-awesome icon="child"></f-awesome>
            </div>
            <div>
              Клиенты
            </div>
          </router-link>
        </li>
        <li v-if="checkPermission('show_stat')">
          <router-link tag="a" :to="`/statistics/`">
            <div>
              <f-awesome icon="chart-pie"></f-awesome>
            </div>
            <div>
              Отчеты
            </div>
          </router-link>
        </li>
        <li v-if="checkPermission('show_salary')">
          <router-link tag="a" :to="`/calc-salary/`">
            <div>
              <f-awesome icon="coins"></f-awesome>
            </div>
            <div>
              Расчет зарплат
            </div>
          </router-link>
        </li>
        <li v-if="checkPermission('user')">
          <router-link tag="a" :to="`/sms/`">
            <div>
              <f-awesome icon="envelope-open"></f-awesome>
            </div>
            <div>
              SMS
            </div>
          </router-link>
        </li>
        <li></li>
        <li v-if="checkPermission('user')">
          <router-link tag="a" :to="`/payment/`">
            <div>
              <f-awesome icon="hand-holding-usd"></f-awesome>
            </div>
            <div>
              Оплата услуг
            </div>
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="`/account/`">
            <div>
              <f-awesome icon="id-card"></f-awesome>
            </div>
            <div>
              Мой аккаунт
            </div>
          </router-link>
        </li>
        <li v-if="checkPermission('user')">
          <router-link tag="a" :to="`/config/`">
            <div>
              <f-awesome icon="cog"></f-awesome>
            </div>
            <div>
              Настройки
            </div>
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="`/support/`">
            <div>
              <f-awesome icon="question-circle"></f-awesome>
            </div>
            <div>
              Поддержка
              <support-notifications-show></support-notifications-show>
            </div>
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="`/faq/`">
            <div>
              <f-awesome icon="graduation-cap"></f-awesome>
            </div>
            <div>
              Обучение
            </div>
          </router-link>
        </li>
      </ul>
    </div>

    <div v-if="showContent" class="main-template-content">
      <div class="main-template--page-title">
        <div>
          <div><slot name="page-title"></slot></div>
        </div>
        <div>
          <div><slot name="page-info"></slot></div>
        </div>
      </div>
      <slot name="page-content"></slot>
    </div>

    <notificator></notificator>
    <preloader></preloader>
    <update-new-version-manual></update-new-version-manual>

    <popup
        :show="newUserPopup.show"
        :closeButton="newUserPopup.closeButton"
        @closePopup="closeNewUserPopup"
    >
      <div slot="header">Вводная информация</div>
      <div slot="body">
        Спасибо за выбор Enroller!<br><br>
        Обратите внимание, для того, <span class="text-orange">чтобы заработала "Онлайн запись"</span>, вам необходимо последовательно
        <span class="text-orange">заполнить следующие разделы: Компании (создать свою компанию), Услуги, Сотрудники и Расписание.</span> <br><br>
        Также, обратите внимание, на иконки <hints type="text"></hints> и <hints type="youtube"></hints> внутри сервиса.
        Нажимая на них, будет открываться окно с подсказками или видео-инструкция о том, как работать с тем или иным разделом
        сервиса.<br><br>
        <b>Инструкция по первоначальной настройке:</b><br>
        <div v-if="newUserPopup.show">
          <iframe
            width="100%"
            height="auto"
            :src="getYotubeLink('firstSetting')"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <br><br>
        Если возникают какие-либо затруднения или дополнительные вопросы, то вы всегда можете написать в Службу Поддержки
      </div>
    </popup>

    <set-manifest></set-manifest>

  </div>
</template>

<script>

import Notificator from "../Notificator";
import Preloader from "../Preloader";
import Bell from "@/components/Bell";
import permissionMixin from "@/components/mixins/Permissions";
import Popup from "@/components/Popup";
import Hints from "@/components/Hints";
import Balance from "../Balance";
import youtubeMixin from "@/components/mixins/Youtube";
import SetManifest from '../SetManifest.vue';
import UpdateNewVersionManual from '../UpdateNewVersionManual.vue';
import SupportNotificationsShow from './support/SupportNotificationsShow.vue';


export default {
  name: "PanelMainTemplate",
  components: {
    Balance, Hints, Popup, Bell, Preloader, Notificator, SetManifest, UpdateNewVersionManual, SupportNotificationsShow},
  mixins: [permissionMixin, youtubeMixin],
  data() {
    return {
      minSidebar: false,
      clientWidth: false,
      showContent: true,
      showAccountBar: false,
      userEmail: false,
      newUserPopup: {
        show: false,
        closeButton: "Закрыть",
      },
    };
  },
  computed: {

  },
  methods: {
    closeNewUserPopup(){
      this.newUserPopup.show = false;
    },
    toggleSidebar() {
      this.minSidebar = !this.minSidebar;
      if (this.minSidebar === false && this.clientWidth < 1000) {
        this.showContent = false;
      } else {
        this.showContent = true;
      }
    },
    toggleAccountBar() {
      this.showAccountBar = !this.showAccountBar;
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/");
      });
    },
    checkNewUserWindow(){
      let newUser = localStorage.getItem("newUser");
      if(newUser == '1'){
        this.newUserPopup.show = true;
        localStorage.removeItem('newUser');
      }
    }
  },
  created() {
    this.checkNewUserWindow();
    this.clientWidth = document.documentElement.clientWidth;
    if (this.clientWidth < 1000) {
      this.minSidebar = true;
    } else {
      this.minSidebar = false;
    }
    let userData = JSON.parse(localStorage.getItem("userData"));
    if(userData){
      this.userEmail = userData[0].email;
    }else{
      this.$router.push('/');
      this.$store.dispatch("stopPreloader");
    }
  }
};
</script>

<style scoped lang="less">
.main-template--page-title {
  display: inline-block;
  padding: 0 10px;
  box-sizing: border-box;
  margin-bottom: 25px;

  & > div:nth-of-type(1) {
    display: inline-block;
    color: #4f4f4f;
    font-weight: 400;
    font-size: 28px;
  }
  & > div:nth-of-type(2) {
    margin-top: 3px;
    font-size: 12px;
    color: gray;
  }
}
.main-template--top-sidebar {
  width: 100%;
  height: 40px;
  position: fixed;
  top: 0;
  background-color: #2b333c;
  color: #fff;
  line-height: 40px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  flex-direction: row;
  z-index: 3;

  .main-template--top-sidebar--humburger {
    width: 45px;
    font-size: 26px;
    position: relative;

    & > svg {
      cursor: pointer;
      transition: all 0.2s;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
    }
    & > svg:hover {
      transform: scale(1.1);
    }
  }
  .main-template--top-sidebar--bell{
    width: 80px;
    text-align: center;
  }
  .main-template--top-sidebar--title {
    padding: 0 15px;

    & > h4 {
      line-height: 40px;
      font-size: 1.5rem;
    }
  }
  .main-template--top-sidebar--null {
    width: 70%;
  }
  .main-template--top-sidebar--account {
    width: 150px;
    text-align: right;
    padding-right: 20px;
    color: #f97979;
    cursor: pointer;
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    flex-direction: row;

    .main-template--top-sidebar-email {
      width: 90%;
      text-overflow: ellipsis;
      overflow: hidden;
      display: inline-block;
      margin-right: 8px;

      .incognito-icon{
        height: 40px;
        position: relative;

        img{
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          margin: auto 0;
        }
      }
    }

    .angle-account{
      height: 40px;
    }

    svg {
      display: inline-block;
    }

    .backside-account-more{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      transform: translate3d(0, 0, 0);
    }

    .main-template--top-sidebar--account-more {
      position: absolute;
      box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.25);
      top: 40px;
      right: 0;
      width: 180px;
      text-align: center;

      .head{
        font-size: 13px;
        text-align: left;
        background-color: #2b333c;
        color: #fff;
        padding: 5px 10px;
        box-sizing: border-box;
        line-height: 25px;
      }
      .links{
        text-align: left;
        padding: 5px 10px;
        background-color: #fff;
        line-height: 30px;

        svg{
          height: 30px;
        }

        .item{
          display: inline-block;
          display: flex;
          flex-wrap: nowrap;
          justify-content: space-around;
          flex-direction: row;
          color: #333;

          &>div:nth-of-type(1){
            width: 20%;
            color: #f97979;
          }
          &>div:nth-of-type(2){
            width: 77%;
            color: #333;
          }
        }
      }
    }
  }
}

.main-template--top-sidebar--notifications {
  display: none;
  position: relative;

  .main-template--top-sidebar--notifications-count {
    position: absolute;
    top: -2px;
    right: -5px;
    color: #fff;
    font-weight: 700;
  }
}
.main-template--top-sidebar--notifications-list {
  width: 200px;
  max-height: 250px;
  overflow: auto;
  position: absolute;
  top: 35px;
  left: 0;
  padding: 18px;
  background-color: #fff;
  color: #333;
  -webkit-box-shadow: 0px 5px 89px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 5px 89px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 5px 89px 0px rgba(0, 0, 0, 0.75);
}
.main-template--top-sidebar--not-item {
  width: 100%;
  margin-top: 12px;
  border-bottom: 0.55px solid #f97979;

  & > div:nth-of-type(1) {
    font-size: 13px;
    /*font-weight: 700;*/
    color: #2b333c;
  }
  & > div:nth-of-type(2) {
    font-size: 11px;
  }
}

.main-template-min-sidebar {
  .main-template-content {
    position: relative;
    margin-left: 0;
  }
  .main-template--left-sidebar {
    display: none;
  }
}
.main-template-content {
  padding-bottom: 35px;
  padding-left: 5px;
  padding-right: 5px;
  box-sizing: border-box;
  margin-top: 45px;
  margin-left: 220px;
}
.main-template--left-sidebar {
  position: fixed;
  top: 40px;
  left: 0;
  bottom: 0;
  width: 210px;
  background-color: #182b49;
  padding: 35px 0 35px 0;
  overflow: auto;
  -webkit-box-shadow: 2px 1px 12px 0px rgba(50, 50, 50, 0.75);
  -moz-box-shadow: 2px 1px 12px 0px rgba(50, 50, 50, 0.75);
  box-shadow: 2px 1px 12px 0px rgba(50, 50, 50, 0.75);

  & > ul {
    list-style-type: none;
    padding: 0;
    margin: 0;

    li {
      width: 90%;
      margin: 0 auto;
      margin-top: 3px;
      padding-top: 6px;

      a {
        font-size: 14px;
        color: #ffffff;
        display: inline-block;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-around;
        flex-direction: row;
        padding: 10px 0;
        box-sizing: border-box;

        & > div:nth-of-type(1) {
          width: 25%;
          font-size: 12px;
          text-align: center;
        }
        & > div:nth-of-type(2) {
          width: 75%;
          font-size: 13px;
        }
      }
      a:hover svg {
        transform: scale(1.1);
      }
    }
    a.router-link-active {
      border-radius: 10px;
      background-color: #2a4063;
      box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.25);
    }
  }
}
@media (max-width: 700px) {
  .main-template--top-sidebar {

    .main-template--top-sidebar--humburger {
      width: 25%;
    }
    .main-template--top-sidebar--bell{
      width: 80px;
    }
    .main-template--top-sidebar--title {
      & > h4 {
        font-size: 1.2rem;
      }
    }
    .main-template--top-sidebar--null {
      width: 70%;
    }
  }
}
@media (max-width: 480px) {
  .main-template--top-sidebar {

    .main-template--top-sidebar--humburger {
      width: 25%;
    }
    .main-template--top-sidebar--bell{
      width: 80px;
    }
    .main-template--top-sidebar--title {
      display: none;
      & > h4 {
        font-size: 1rem;
      }
    }
    .main-template--top-sidebar--null {
      width: 30%;
    }
  }
}
</style>
